import type { MenuOpenType, StatusType } from './menu.enums';
import type { IOption } from './option';

export const MENU_OPEN_OPTIONS: IOption<MenuOpenType>[] = [
  { value: 'Same', label: 'Same Page' },
  { value: 'Model', label: 'Model' },
  { value: 'Blank', label: 'Blank' },
];

export const STATUS_OPTIONS: IOption<StatusType>[] = [
  { value: 'Active', label: 'Active' },
  { value: 'Inactive', label: 'Inactive' },
];

export const SEQUENCE_OPTIONS: IOption<number>[] = Array.from(
  { length: 10 },
  (_, i) => ({
    value: i + 1,
    label: `${i + 1}`,
  })
);
